import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { useGetCompanyProfileQuery } from "../services/companySlice";
import { RootState } from "../store";
import { hasRole } from "../utils/roleHelpers";

const ProtectedRoute = ({ children }: { children: React.JSX.Element }) => {
  const token = useSelector((state: RootState) => state.auth.token);
  const user = useSelector((state: RootState) => state.auth.user);
  const { data: profile, isLoading } = useGetCompanyProfileQuery();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/auth" />;
  }

  const hasValidProfile = profile?.companyName;
  const isCustomer = hasRole(user?.roles, "customer");

  // Only customers need a company profile
  if (
    !isLoading &&
    !hasValidProfile &&
    isCustomer &&
    location.pathname !== "/edit-profile"
  ) {
    return <Navigate to="/edit-profile" replace />;
  }

  return children;
};

export default ProtectedRoute;
